<template>
  <el-main>
    <component :is="require('./images/home').default" />
  </el-main>
</template>

<script>
export default {
  name: "home"
};
</script>

<style scoped lang="stylus">
.el-main {
    padding: 0;
    margin: 0;
    overflow: hidden;
    background-color: #2c3e50;

    svg {
        height: auto;
        width: 100%;
    }
}
</style>
